import { IconPosition } from 'src/app/shared/types/icon-types';

export enum MessageSegmentType {
  Text = 'text',
  Tip = 'tip',
  Currency = 'currency',
  Date = 'date',
}

export interface MessageSegment {
  type: MessageSegmentType;
  content: string;
  icon?: string;
  iconPosition?: IconPosition;
}

export interface StructuredHintMessage {
  id: string;
  segments: MessageSegment[];
}
